/**
 * Configuration for quiz result groups on the summary slide.
 * Groups are selected based on percentage of correct answers.
 */
const experienceResultsConfig = {
    groups : [
        {
            id            : 'beginner',
            minPercentage : 0,
            maxPercentage : 42,
            title         : 'Первая вахта',
            description   : 'Вы только пришли на&nbsp;платформу и&nbsp;пока осваиваетесь. Но&nbsp;со&nbsp;временем вы станете полноценным членом команды. Ваше желание учиться поможет вам быстро адаптироваться.',
            image         : {
                src : 'images/result/result-3',
                alt : 'Первая вахта'
            }
        },
        {
            id            : 'intermediate',
            minPercentage : 43,
            maxPercentage : 85,
            title         : 'Покоритель льдов',
            description   : 'Вы показали уверенный результат - знаете главное и&nbsp;умеете действовать в&nbsp;сложных условиях. Немного доработав точность и&nbsp;добавив практики в&nbsp;ключевых моментах, сможете смело выходить на&nbsp;новый уровень.',
            image         : {
                src : 'images/result/result-2',
                alt : 'Покоритель льдов'
            }
        },
        {
            id            : 'expert',
            minPercentage : 86,
            maxPercentage : 100,
            title         : 'Компас «Приразломной»',
            description   : 'Вы глубоко разбираетесь в&nbsp;нефтедобыче и&nbsp;готовы брать на&nbsp;себя ответственность за&nbsp;ключевые задачи. Такой уровень экспертизы позволяет рассчитывать на&nbsp;руководящие роли в&nbsp;команде «Приразломной». Ваш опыт и&nbsp;решения помогут найти путь даже во&nbsp;тьме полярной ночи.',
            image         : {
                src : 'images/result/result-1',
                alt : 'Компас «Приразломной»'
            }
        }
    ],
    defaultGroupId : 'beginner'
};

export default experienceResultsConfig;
